export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8477.4c3a3c3d.jpg";